module.exports = __webpack_public_path__ + "img/React Native.580ffd26.png";